// Каталог валют форм — GET /api/currencies (только active, authenticated; BE W8).

import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import { setCurrencySymbols } from '@/lib/format';

/** Элемент каталога валют (wire CatalogView). */
export interface Currency {
  /** ISO-3 код. */
  code: string;
  /** Отображаемый символ. */
  symbol: string;
  /** В каталоге форм всегда true. */
  active: boolean;
}

/** Сообщение при сбое GET /api/currencies (не хардкод четырёх кодов). */
export const CURRENCIES_LOAD_ERROR = 'Не удалось загрузить валюты';

/** staleTime каталога: справочник меняется редко. */
const CURRENCIES_STALE_TIME_MS = 5 * 60 * 1000;

/** API публичного каталога валют (только active). */
export const currenciesApi = {
  /** GET /api/currencies → список активных валют. */
  async listActive(): Promise<Currency[]> {
    const { data } = await apiClient.get<Currency[]>('/api/currencies');
    return data;
  },
};

/**
 * Хук активных валют для селектов форм (один queryKey).
 * Побочно наполняет карту символов {@link setCurrencySymbols}.
 */
export function useActiveCurrencies() {
  return useQuery({
    queryKey: ['currencies', 'active'],
    queryFn: async () => {
      const list = await currenciesApi.listActive();
      setCurrencySymbols(Object.fromEntries(list.map((c) => [c.code, c.symbol])));
      return list;
    },
    staleTime: CURRENCIES_STALE_TIME_MS,
    retry: false,
  });
}
